var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWozekWidlowy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200.66 135.32",
    width: 90,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .d {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 7.93px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#000",
    cx: 68.05,
    cy: 116.19,
    r: 15.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#000",
    d: "M196.69,104.73c-.22-9.65-3.11-22.96-13.14-38.99h-28.82l-7.86-61.77h-47.63l-31.4,79.94c.07,0,.14,0,.21,0,17.83,0,32.29,14.46,32.29,32.29,0,1.99-.19,3.93-.53,5.81h34.94c-.34-1.89-.53-3.83-.53-5.81,0-13.37,8.13-24.85,19.72-29.75"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#000",
    cx: 166.5,
    cy: 116.19,
    r: 15.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 52.88,
    y1: 3.97,
    x2: 52.88,
    y2: 86.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 3.97,
    y1: 116.19,
    x2: 36.1,
    y2: 116.19
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWozekWidlowy);
export default __webpack_public_path__ + "static/media/wozek_widlowy.0e430bdb67d3d3aa13539b6a57034ae0.svg";
export { ForwardRef as ReactComponent };